import React,{useState} from 'react'
import useUserList from '../../../hooks/useUserList';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import documentServices from '../services/documentServices';
import { useAlert } from '../../../context/AlertContext';

function DocumentAssign({documentDetail,callBack}) {
    const {userList,getUserName} = useUserList();
    const {AppAlert} = useAlert();
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const getActivityRemark = (assignedTo) =>{
        
        if(documentDetail.assignedTo == null ){
            return ' Assignee to "'+getUserName(assignedTo)+'"';
        }
        return ' Assignee "'+getUserName(documentDetail.assignedTo)+'" to "'+getUserName(assignedTo)+'"';
    }

     const updateAssignee = (assignedTo) =>{
        let payload = {
            documentId:documentDetail.id,
            remark:getActivityRemark(assignedTo),
            assignedTo:assignedTo,
        }
        
        setSavingStatus(true);
        documentServices.updateAssignee(payload).then(res=>{
            console.log(res);
            AppAlert(res.msg)
            callBack();
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
        
    }
    
    return (
        userList &&
        <>
            <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(true)} >
                {documentDetail.assignedTo !== null ?
                    getUserName(documentDetail.assignedTo)
                    :
                    "--None--"
                }
            </button>

            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogTitle> Update Assignee : <button className='btn btn-primary'> 
                    {documentDetail.assignedTo !== null ?
                        getUserName(documentDetail.assignedTo)
                        :
                        "--None--"
                    } 
                </button></DialogTitle>
                <DialogContent>
                    <div className='mt-2'>
                        {userList.map(u=>
                            u.value != documentDetail.assignedTo && <button className='btn btn-outline-primary m-2' key={u.value} onClick={()=>updateAssignee(u.value)} > {u.firstName} {u.lastName} </button>
                        )}
                    </div>
                </DialogContent>
            </Dialog>
        </>
    ) 
}

export default DocumentAssign